import { apiRequest } from './http';
import type {
  ApproveRejectBody,
  CreateRequestResponse,
  GrantRequestBody,
  ProjectCreateRequestBody,
  ProjectEditRequestBody,
  RequestListResponse,
  RequestRecord,
  RequestStatus,
  RequestType,
  RevokeRequestBody,
  StageGrantRequestBody,
} from './types';

// §5.11 GET /api/requests
export interface RequestsQuery {
  status?: RequestStatus;
  mine?: boolean;
  type?: RequestType;
  page?: number;
  page_size?: number;
}

export function fetchRequests(
  query: RequestsQuery = {},
  signal?: AbortSignal,
): Promise<RequestListResponse> {
  return apiRequest<RequestListResponse>('/requests', {
    query: query as { [key: string]: unknown },
    signal,
  });
}

// §5.12 GET /api/requests/{id}
export function fetchRequest(id: number, signal?: AbortSignal): Promise<RequestRecord> {
  return apiRequest<RequestRecord>(`/requests/${id}`, { signal });
}

// §5.13 POST /api/requests/grant
export function createGrantRequest(body: GrantRequestBody): Promise<CreateRequestResponse> {
  return apiRequest<CreateRequestResponse>('/requests/grant', { method: 'POST', body });
}

// §5.14 POST /api/requests/revoke
export function createRevokeRequest(body: RevokeRequestBody): Promise<CreateRequestResponse> {
  return apiRequest<CreateRequestResponse>('/requests/revoke', { method: 'POST', body });
}

// POST /api/requests/stage-grant
export function createStageGrantRequest(body: StageGrantRequestBody): Promise<CreateRequestResponse> {
  return apiRequest<CreateRequestResponse>('/requests/stage-grant', { method: 'POST', body });
}

// §5.15 POST /api/requests/project-create
export function createProjectCreateRequest(
  body: ProjectCreateRequestBody,
): Promise<CreateRequestResponse> {
  return apiRequest<CreateRequestResponse>('/requests/project-create', { method: 'POST', body });
}

// §5.16 POST /api/requests/project-edit
export function createProjectEditRequest(
  body: ProjectEditRequestBody,
): Promise<CreateRequestResponse> {
  return apiRequest<CreateRequestResponse>('/requests/project-edit', { method: 'POST', body });
}

// §5.17 POST /api/requests/{id}/approve
export function approveRequest(id: number, body: ApproveRejectBody = {}): Promise<RequestRecord> {
  return apiRequest<RequestRecord>(`/requests/${id}/approve`, { method: 'POST', body });
}

// §5.18 POST /api/requests/{id}/reject
export function rejectRequest(id: number, body: ApproveRejectBody = {}): Promise<RequestRecord> {
  return apiRequest<RequestRecord>(`/requests/${id}/reject`, { method: 'POST', body });
}

// §5.19 POST /api/requests/{id}/retry-sync
export function retrySyncRequest(id: number): Promise<RequestRecord> {
  return apiRequest<RequestRecord>(`/requests/${id}/retry-sync`, { method: 'POST' });
}
